// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list__header[data-v-50a7f5e5]{display:flex;justify-content:center;align-items:center;margin-bottom:.25rem}.list__header-title[data-v-50a7f5e5]{flex-grow:1}.list__jobs[data-v-50a7f5e5]{display:flex;flex-wrap:wrap}.list__job[data-v-50a7f5e5]{width:25%;padding:.25rem}@media (max-width:959px){h2[data-v-50a7f5e5]{margin-bottom:.5rem;font-size:1.25rem}.list__job[data-v-50a7f5e5]{width:50%}}", ""]);
// Exports
module.exports = exports;
